export default __webpack_public_path__ + "static/media/vid-03.5f61bf84.mp4";